import { render, staticRenderFns } from "./readonlyview.vue?vue&type=template&id=577037b6&"
import script from "../../ts/readonlymode/readonlyview.ts?vue&type=script&lang=js&"
export * from "../../ts/readonlymode/readonlyview.ts?vue&type=script&lang=js&"
import style0 from "../../assets/css/readonlymode/readonlyview.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports